import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-value-section {
  display: grid;
  gap: ${dt('appValueSection.gap')};

  & p.title {
    padding: 0px;
    margin: 0px;
    color: ${dt('appValueSection.title.color')};
    font-weight: ${dt('appValueSection.title.fontWeight')};
    font-size: ${dt('appValueSection.title.fontSize')};
    line-height: ${dt('appValueSection.title.lineHeight')};
  }

  & div.content {
    padding: 0px;
    margin: 0px;

    & p.title {
      padding: 0px;
      margin: 0px;
      color: ${dt('appValueSection.content.title.color')};
      font-weight: ${dt('appValueSection.content.title.fontWeight')};
      font-size: ${dt('appValueSection.content.title.fontSize')};
      line-height: ${dt('appValueSection.content.title.lineHeight')};
    }

    & p.value {
      padding: 0px;
      margin: 0px;
      color: ${dt('appValueSection.content.value.color')};
      font-weight: ${dt('appValueSection.content.value.fontWeight')};
      font-size: ${dt('appValueSection.content.value.fontSize')};
      line-height: ${dt('appValueSection.content.value.lineHeight')};
    }
  }
}

.app-value-section--field > p.title {
  color: ${dt('appValueSection.fieldTitle.color')};
  font-weight: ${dt('appValueSection.fieldTitle.fontWeight')};
}`;
